import { CHEF_ROLES } from '../const';
import { holidaysOnDate } from './holidays';

const HOLIDAY_CLIENT_RATE = 1.35
const HOLIDAY_STAFF_RATE = 1.30
const TIP_MULTIPLIER = 0.20

export const getTips = (district, guestCount, date, extendedMenu) => {
  const rateTable = extendedMenu ? clientRatesExtendedMenu : clientRates;
  const rates = getRates(rateTable, district, guestCount);
  const holiday = holidaysOnDate(date)
  const rateMultiplier = holiday ? HOLIDAY_CLIENT_RATE : 1

  return {
      chefTip: rates[1] * rateMultiplier * TIP_MULTIPLIER,
      sousChefTip: rates[2] * rateMultiplier * TIP_MULTIPLIER,
      bartenderTip: rates[3] * rateMultiplier * TIP_MULTIPLIER,
  }
};

export const getClientFee = (district, guestCount, date, invitedChefs, extendedMenu) => {
  const rateTable = extendedMenu ? clientRatesExtendedMenu : clientRates;
  const rates = getRates(rateTable, district, guestCount);
  let sum = 0;
  const holiday = holidaysOnDate(date)
  const rateMultiplier = holiday ? HOLIDAY_CLIENT_RATE : 1
  for (const invite of invitedChefs) {
    if (invite.role === CHEF_ROLES['CHEF']) {
      sum += rates[1] * rateMultiplier
    } else if (invite.role === CHEF_ROLES['SOUS_CHEF']) {
      sum += rates[2] * rateMultiplier
    } else {
      sum += rates[3] * rateMultiplier;
    }
  }
  return (sum * 100).toFixed(0);
};

export const getChefRate = (district, guestCount, date, vipLevel, role) => {
  const rates = getRates(chefRates, district, guestCount);
  const holiday = holidaysOnDate(date)
  const rateMultiplier = holiday ? HOLIDAY_STAFF_RATE : 1

  let newRate = rates[0];
  if (role === CHEF_ROLES['SOUS_CHEF']) {
    newRate = rates[5];
  } else if (
    [CHEF_ROLES['BARTENDER'], CHEF_ROLES['WAITER']].includes(role)
  ) {
    newRate = rates[6];
  } else {
    newRate = rates[vipLevel + 1];
  }
  return (newRate * 100 * rateMultiplier).toFixed();
};

// get correct row based on parameters given
export const getRates = (
  ratesMatrix,
  district,
  guestCount
) => {
  let rates = ratesMatrix['DEFAULT'];
  switch (district) {
    case 'NYC':
    case 'LA':
    case 'DC':
    case 'CORE':
      rates = ratesMatrix['NYC, LA, DC'];
      break;
    case 'HMP':
    case 'PREMIUM':
      rates = ratesMatrix['HMP'];
      break;
    default:
  }

  for (const rate of rates) {
    if (guestCount <= rate[0]) {
      return rate;
    }
  }
};

/****** AUTOFILL RATES DATA *********/
const clientRates = {
  //Rates in Order: MAX_GUETS, CHEF, SOUS CHEF, WAITER / BARTENDER
  'NYC, LA, DC': [
    [6, 500, 0, 250],
    [11, 750, 0, 250],
    [14, 1000, 500, 250],
    [20, 1000, 500, 250],
    [29, 1000, 500, 250],
    [35, 1000, 500, 250],
    [45, 1000, 500, 250],
    [Infinity, 1000, 500, 250],
  ],
  DEFAULT: [
    [12, 1000, 0, 300],
    [14, 1250, 0, 300],
    [20, 1000, 0, 300],
    [30, 1000, 0, 300],
    [Infinity, 1000, 0, 300],
  ],

  // HAMPTONS
  HMP: [
    [6, 1000, 0, 300],
    [12, 1250, 0, 300],
    [14, 1250, 0, 300],
    [29, 1500, 0, 300],
    [Infinity, 1000, 0, 300],
  ],
};

const clientRatesExtendedMenu = {
  //Rates in Order: MAX_GUETS, CHEF, SOUS CHEF, WAITER / BARTENDER
  'NYC, LA, DC': [
    [6, 500, 0, 250],
    [11, 750, 0, 250],
    [14, 900, 500, 250],
    [20, 900, 500, 250],
    [29, 900, 500, 250],
    [35, 950, 500, 250],
    [45, 950, 500, 250],
    [Infinity, 1000, 500, 250],
  ],
  DEFAULT: [
    [12, 1000, 0, 300],
    [14, 1000, 0, 300],
    [20, 1000, 0, 300],
    [30, 1000, 0, 300],
    [Infinity, 1000, 0, 300],
  ],

  // HAMPTONS
  HMP: [
    [6, 1000, 0, 300],
    [12, 1000, 0, 300],
    [14, 1000, 0, 300],
    [29, 1000, 0, 300],
    [Infinity, 1000, 0, 300],
  ],
};

const chefRates = {
  //Rates in Order: MAX_GUETS, STANDARD, VIP 1, VIP 2, VIP 3, SOUS, BARTENDER / WAITER
  'NYC, LA, DC': [
    [6, 350, 350, 350, 350, 200, 150],
    [11, 350, 350, 350, 350, 200, 150],
    [14, 350, 400, 400, 400, 200, 150],
    [20, 350, 400, 400, 400, 200, 150],
    [29, 350, 400, 400, 400, 200, 150],
    [35, 350, 400, 400, 400, 200, 150],
    [44, 350, 400, 400, 400, 200, 150],
    [Infinity, 350, 400, 400, 400, 200, 150],
  ],
  HMP: [
    // HAMPTONS
    [6, 500, 500, 550, 600, null, 200],
    [12, 500, 500, 550, 600, null, 200],
    [14, 500, 500, 550, 600, null, 200],
    [29, 550, 550, 600, 650, null, 200],
    [Infinity, 600, 600, 650, 700, null, 200],
  ],
  DEFAULT: [
    // ALL Other
    [12, 500, 500, 550, 600, null, 200],
    [14, 500, 500, 550, 600, null, 200],
    [20, 500, 500, 550, 600, null, 200],
    [Infinity, 500, 500, 550, 600, null, 200],
  ],
};



// WEBPACK FOOTER //
// ./src/helpers/getAutofillRates.js